import { mapGetters } from "vuex";
import _ from "lodash";
import Loader from "@/components/loader/Loader.vue";
import { EventBus } from "@/services/EventBus";
import { playerEvents } from "./const/playerEvents";

export default {
  name: "Player",
  components: {
    Loader
  },
  props: {
    data: {
      type: Object
    }
  },
  inject: ["auth"],
  data() {
    return {
      domain: location.origin,
      loading: true,
      options: {
        login: this.$store.state.user.login,
        password: this.auth.getTokenFromStorage(
          localStorage.getItem("token")
        )[1],
        monitor_id: PARAMS.PLAYER.monitorId,
        transport: PARAMS.PLAYER.transport
      },
      camsData: null,
      intervalDateVideo: null,
      isShowSolo: false
    };
  },
  computed: {
    ...mapGetters({
      stream: "getStream"
    }),
    params() {
      return {
        ...this.options,
        ...this.data,
        stream_role: this.stream
      };
    }
  },
  watch: {
    stream() {
      this.sendMessage({
        command: playerEvents.INIT,
        stream_role: this.stream
      });
    },
    "$store.state.i18n.locale"() {
      this.initiatePlayer();
    }
  },
  created() {
    window.addEventListener("message", this.getMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.getMessage);
    EventBus.$off("views:select");
    EventBus.$off("mode:change");
    EventBus.$off("cam:dragstart");
    EventBus.$off("export-files");
    EventBus.$off("stop-export-file");
  },
  mounted() {
    EventBus.$on("views:select", this.update);
    EventBus.$on("mode:change", this.changeMode);
    EventBus.$on("cam:dragstart", this.getCamsData);
    EventBus.$on("export-files", this.exportFiles);
    EventBus.$on("stop-export-file", this.stopExportFile);

    this.initiatePlayer();
  },
  methods: {
    initiatePlayer() {
      this.preloading();

      const startForm = document.createElement("form");
      startForm.setAttribute("method", "post");
      startForm.setAttribute("target", "webview_player");
      startForm.setAttribute("action", "/webview/video");
      startForm.setAttribute("style", "display: none");
      let startFromHtml = "";

      const paramsSend = {
        command: playerEvents.SHOW_MONITOR,
        auto_logon: 1,
        close_current_session: 1
      };

      Object.assign(paramsSend, this.params);
      Object.keys(paramsSend).forEach(key => {
        startFromHtml += `<input name="${key}" value="${paramsSend[key]}">`;
      });
      startForm.innerHTML = startFromHtml;
      document.body.appendChild(startForm);
      startForm.submit();
      startForm.remove();
    },
    update() {
      this.isShowSolo = false;

      if (this.params) {
        const data = {
          command: playerEvents.SHOW_MONITOR,
          monitor_id: this.params.monitor_id,
          mode: this.params.mode,
          geometry: this.params.geometry,
          camera_list: this.params.camera_list.join(","),
          layout: this.params.layout,
          stream_role: this.params.stream_role
        };

        if (this.params.time) data.time = this.params.time;

        this.sendMessage(data);
      }
    },
    changeMode() {
      this.sendMessage({
        command: playerEvents.CHANGE_MONITOR_MODE,
        mode: this.params.mode
      });
    },
    sendMessage(data) {
      if (this.$refs.player)
        this.$refs.player.contentWindow.postMessage(JSON.stringify(data), "*");
    },
    preloading() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 1500);
    },
    getCamsData() {
      this.sendMessage({
        command: playerEvents.GET_CAMERAS_DATA,
        request_id: 1
      });
    },
    exportFiles(data) {
      const startDateFormat = data.start_date.creationData().format;
      const endDateFormat = data.end_date.creationData().format;
      const startDateView = data.start_date.format(startDateFormat);
      const endDateView = data.end_date.format(endDateFormat);
      const formatSend = "DD-MM-YYYY HH:mm:ss.000";
      data.start_date = data.start_date.format(formatSend);
      data.end_date = data.end_date.format(formatSend);
      this.intervalDateVideo = `${startDateView.slice(
        0,
        16
      )} - ${endDateView.slice(0, 16)}`;
      const exportParams = {
        ...data,
        command: playerEvents.START_EXPORT
      };
      this.sendMessage(exportParams);
    },
    stopExportFile(id) {
      this.sendMessage({
        command: playerEvents.STOP_EXPORT,
        id: id
      });
    },
    getMessage(event) {
      if (event && event.data && typeof event.data === "string") {
        let data = JSON.parse(event.data);

        switch (data.action) {
          case playerEvents.ALERTS:
            this.$router.push({
              name: "alarms",
              query: { cams: data.camera_id }
            });
            break;
          case playerEvents.ON_MAP:
            let params = null;

            this.$store.state.maps.forEach(item => {
              item.map.forEach(i => {
                i.objects.forEach(o => {
                  if (data.camera_id == o.id)
                    params = { mapGroupId: item.id, mapId: i.id };
                });
              });
            });

            if (params) {
              this.$store.commit("setCamIdFromCell", data.camera_id);
              this.$router.push({ name: "map", params: params });
            }
            break;

          case playerEvents.SET_PLAYER_MODE:
            this.$store.commit("setMode", data.mode);
            break;

          case playerEvents.CLOSE_CAMERA: {
            this.$store.commit("removeCamFromView", {
              camId: data.camera_id,
              viewId: this.$store.getters.getActiveView.id
            });

            if (this.isShowSolo) {
              this.$nextTick(() => this.update());
            }

            break;
          }

          case playerEvents.ADD_CAMERA:
            if (this.camsData) {
              this.camsData.list.forEach(item => {
                if (item.camera_index == data.camera_index) {
                  if (item.camera_id === "null") {
                    this.$store.commit("addCamsIntoView", {
                      camIds: [data.camera_id],
                      viewId: this.$store.getters.getActiveView.id
                    });
                  } else {
                    this.$store.commit("replaceCam", {
                      camId: data.camera_id,
                      replacedCamId: item.camera_id,
                      viewId: this.$store.getters.getActiveView.id
                    });
                  }
                }
              });
            }

            break;

          case playerEvents.GET_CAMERAS_DATA:
            this.camsData = data;
            break;
          case playerEvents.LONG_POOL_UPLOAD: {
            this.$store.commit("setUplodedVideos", {
              ...data,
              intervalDateVideo: this.intervalDateVideo
            });
            break;
          }

          case playerEvents.PLAYER_DOUBLE_CLICK: {
            this.isShowSolo = !this.isShowSolo;

            const messageData = {
              command: playerEvents.SHOW_MONITOR,
              monitor_id: this.params.monitor_id,
              geometry: this.isShowSolo ? "" : this.params.geometry,
              mode: this.params.mode,
              camera_list: this.isShowSolo
                ? data.camera_id
                : this.params.camera_list.join(","),
              layout: this.isShowSolo ? 1 : this.params.layout,
              time: data.date
            };

            if (this.params.time) {
              messageData.time = this.params.time;
            }

            this.sendMessage(messageData);
          }
        }

        switch (data.command) {
          case playerEvents.EXPORT_CONTROL:
            EventBus.$emit("open:export", data.camera_id);
            break;
          case playerEvents.INIT:
            if (+data.arch_cnv_enabled === 0) {
              this.$store.commit("setArchCnvEnabled", false);
            } else {
              this.$store.commit("setArchCnvEnabled", true);
            }
            break;
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/player/player.js